import createSvgIcon from '../Utils/CreateSvgIcon';

export const BodyColorBlack = createSvgIcon(
  <circle cx="10" cy="10" fill="#1D1D1D" r="10" transform="matrix(1 0 0 -1 2 22)" />,
  'BodyColorBlack',
);
